// AvatarStack.tsx
type AvatarStackProps = {
    images: string[];
    size?: number; // avatar diameter in px
    overlap?: number; // how much to overlap (0–1)
    borderWidth?: number; // white ring thickness
    borderColor?: string;
    alts?: string[];
    titles?: string[];
};

export function AvatarStack({
    images,
    titles = [],
    alts = [],
    size = 72,
    overlap = 0.32,
    borderWidth = 3,
    borderColor = "#fff",
}: AvatarStackProps) {
    const overlapPx = Math.round(size * overlap);

    return (
        <div style={{ display: "flex", alignItems: "center" }}>
            {images.map((src, i) => (
                <img
                    key={src + i}
                    src={src}
                    alt={alts[i] || "Office Hub team member"}
                    title={titles[i]}
                    style={{
                        width: size,
                        height: size,
                        objectFit: "cover",
                        borderRadius: "50%",
                        border: `${borderWidth}px solid ${borderColor}`,
                        background: "#dfe6ea",
                        boxSizing: "content-box",
                        marginLeft: i === 0 ? 0 : -overlapPx,
                        boxShadow: "0 0 0 1px rgba(0,0,0,0.04)",
                    }}
                />
            ))}
        </div>
    );
}